/**
 * Shared severity → jem-ui Tag variant mapping for the fraud-review surfaces.
 * Mirrors the backend SEVERITY_ORDER (ok < low < medium < high < critical).
 */
import { FraudSeverity } from '../../../../../services/verificationClient';

export function severityTagVariant(
  severity: FraudSeverity | null | undefined
): 'success' | 'pending' | 'processing' | 'failed' {
  switch (severity) {
    case 'critical':
    case 'high':
      return 'failed';
    case 'medium':
      return 'pending';
    case 'low':
      return 'processing';
    case 'ok':
      return 'success';
    case 'unknown':
    default:
      return 'processing';
  }
}
